const map = {
	"./2010/Sponsors/Index.vue": 26987,
	"./2011/Sponsors/Index.vue": 85405,
	"./2012/Sponsors/Index.vue": 32674,
	"./2013/Sponsors/Index.vue": 10759,
	"./2014/Sponsors/Index.vue": 71099,
	"./2015/Sponsors/Index.vue": 22047,
	"./2016/Sponsors/Index.vue": 33983,
	"./2017/Sponsors/Index.vue": 20731,
	"./2018/Sponsors/Index.vue": 60371,
	"./2019/Sponsors/Index.vue": 92368,
	"./2021/Sponsors/Index.vue": 46821,
	"./2022/Sponsors/Index.vue": 68465,
	"./2023/Sponsors/Index.vue": 75030,
	"./2024/Sponsors/Index.vue": 42069,
	"./2025/Sponsors/Index.vue": 93159,
	"./2026/Sponsors/Index.vue": 17955
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54810;